import { TypeResponse } from 'gtd-ng-widget';

export class ProfileResponse extends TypeResponse {
  id: number;
  name: string;
  first_name: string;
  last_name: string;
  email: string;
  is_active: boolean;
  country_code: string;
  created_at: number;
  updated_at: number;
  status: string | number;
  birthday: string;
  phone: string;
  ms_teams: string;
  telegram: string;
  whatsapp: string | null;
  affiliate_offer_tracking_domain: {
    id: number;
    tracking_domain: {
      name: string;
    };
  };
  description: string;
  telegram_id: number;
  otp: boolean;
  currency_code: string;
  advertisers: IAdvertiser[];
  only_qualified_postback: boolean;
  enable_shared_fees: boolean;
}

interface IAdvertiser {
  id: string;
  name: string;
  external_id: string;
}
